import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
interface RefundSubscriptionProps {
  reason: string
  id: string
  billingCycle: number
}
const useRefundSubscription = (id: string, billingCycle: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({
      reason,
      id,
      billingCycle,
    }: RefundSubscriptionProps) => {
      const url = `${ENDPOINTS.SUBSCRIPTION}/${id}/cycle/${billingCycle}/refund`
      const body = {
        reason,
        termsServices: true,
      }
      await api.put(url, body)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.SUBSCRIPTION, { id, billingCycle }],
      })
    },
  })
}
export default useRefundSubscription
